// extracted by mini-css-extract-plugin
export default {"navmain":"Nav_navmain__A75Ec","navmain1":"Nav_navmain1__spXGH","navbar2":"Nav_navbar2__dlvOp","buttonnav":"Nav_buttonnav__lVYkz"};